import { render, staticRenderFns } from "./ApplyJoinGroup.vue?vue&type=template&id=2954d174&scoped=true"
import script from "./ApplyJoinGroup.vue?vue&type=script&lang=js"
export * from "./ApplyJoinGroup.vue?vue&type=script&lang=js"
import style0 from "./ApplyJoinGroup.vue?vue&type=style&index=0&id=2954d174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2954d174",
  null
  
)

export default component.exports